<script>
    export default {
        data() {
            return {
                isAboveThreshold: this.evaluateThreshold(),
            };
        },
        computed: {
            threshold() {
                return this.$el.clientHeight;
            },
        },
        mounted() {
            this.registerEventListeners();
            this.evaluate();
        },
        methods: {
            registerEventListeners() {
                let event = [
                    'scroll', () => {
                        this.isAboveThreshold = this.evaluateThreshold();
                        this.evaluate();
                    }];

                window.addEventListener(...event);

                this.$once('hook:beforeDestroy', () => {
                    document.removeEventListener(...event);
                });

                window.EventHandler.listen('window-resized', this.evaluate);
            },
            evaluateThreshold() {

                let distance = document.documentElement.scrollTop || document.body.scrollTop || 0;

                return distance > this.threshold;
            },
            evaluate() {
                if (this.isAboveThreshold) {
                    this.$el.classList.add('above-threshold');
                } else {
                    this.$el.classList.remove('above-threshold');
                }
            },
        },
        render() {
            return this.$slots.default[0];
        },
    };
</script>
